//http://images.autodesk.com/adsk/files/autocad_2012_pdf_dxf-reference_enu.pdf
//https://ezdxf.readthedocs.io/en/stable/dxfinternals/filestructure.html
//https://dxfwrite.readthedocs.io/en/latest/index.html
import { dxfFloat } from "./NodeDXF/dxfFloat";
import debugModule from "debug";
export const debug = new debugModule("NodeDXF2");
import { DXFSpace, CreateDXFObject } from "./DXFOBJECT";
export { DXFSpace, CreateDXFObject } from "./DXFOBJECT";
export function isObject(objValue) {
    return (objValue && typeof objValue === "object" && objValue.constructor === Object);
}
export let BIGNUMEBR = 99999999999;
export let SMALLNUMBER = -BIGNUMEBR;
export const TYPE_FOLD = "FOLD";
export const TYPE_CUT = "CUT";
export const TYPE_IGNORE = "IGNORE";
export function nodedxf2(data, retry = false) {
    var i = 0;
    var primary = new DXFSpace.DXFOBJECT("DXF", retry, 0);
    var o = primary;
    var p = null;
    let errors = [];
    var lastVar = null;
    var lastSub = null;
    const lines = data.split(/\r?\n/);
    let numLines = lines.length;
    var tempcode = lines.shift();
    while (lines.length > 0 && i < 10) {
        let code = dxfFloat(tempcode.trim());
        let VALUE = lines.shift().trim();
        switch (code) {
            case 0:
                if (["ENDSEC", "ENDTAB", "ENDBLK"].indexOf(VALUE) >= 0) {
                    lastVar = null;
                    lastSub = null;
                    // console.groupEnd();
                }
                else {
                    if (["SECTION", "TABLE", "BLOCK"].indexOf(VALUE) >= 0) {
                        // console.group(numLines - lines.length, VALUE);
                    }
                    else {
                        // console.log(numLines - lines.length, VALUE);
                    }
                    let newo = CreateDXFObject(VALUE, retry, numLines - lines.length);
                    lastSub = newo;
                    if (["SECTION"].indexOf(VALUE) >= 0) {
                        primary.addObject(newo);
                        p = newo;
                    }
                    else {
                        if (["SEQEND", "VERTEX"].indexOf(VALUE) >= 0) {
                            p.last().addObject(newo);
                        }
                        else {
                            p.addObject(newo);
                        }
                        o = newo;
                    }
                }
                break;
            case 1:
                o.Value = VALUE;
                break;
            case 2:
                o.NAME = VALUE;
                break;
            case 3:
                o.EntryNAME = VALUE;
                break;
            case 4:
            case 5:
                o.Handle = VALUE;
                break;
            case 6:
                o.LINEType = VALUE;
                break;
            case 7:
                if (lastSub) {
                    lastSub["Something" + code] = VALUE;
                }
                else {
                    if (!lastVar)
                        debug("lastSub", code, lastSub, lastVar);
                    o.setVar(lastVar, VALUE, code);
                }
                break;
            case 8: //Layer name
                if (lastSub)
                    lastSub.NAME = VALUE;
                else {
                    if (lastVar)
                        o.setVar(lastVar, VALUE, code);
                    else
                        o.NAME = VALUE;
                }
                break;
            case 9:
                // console.log("VarName", tmp9);
                lastVar = VALUE;
                o.setVar(lastVar, null, code);
                break;
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
                if (lastSub) {
                    lastSub.setX("" + code, "X", dxfFloat(VALUE));
                }
                else
                    o.setX("" + code, lastVar, dxfFloat(VALUE));
                break;
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
                if (lastSub) {
                    lastSub.setY("" + code, "Y", dxfFloat(VALUE));
                }
                else
                    o.setY("" + code, lastVar, dxfFloat(VALUE));
                break;
            case 30:
            case 31:
            case 32:
            case 33:
            case 34:
            case 35:
            case 36:
            case 37:
            case 38:
            case 39:
                //   debug('X', lines.shift(), lastVar);
                if (lastSub) {
                    lastSub.setZ("" + code, "Z", dxfFloat(VALUE));
                }
                else
                    o.setZ("" + code, lastVar, dxfFloat(VALUE));
                break;
            case 40:
                if (lastSub) {
                    lastSub.Radius = VALUE; //AcDbCircle
                }
                else {
                    o.setVar(lastVar, VALUE, code);
                }
                break;
            case 41:
                if (lastSub) {
                    lastSub.EndWidth = VALUE; //AcDbPolyline
                }
                else
                    o.setVar(lastVar, VALUE, code);
                break;
            case 42:
                if (lastSub) {
                    lastSub.Bulge = VALUE; // AcDbPolyline
                }
                else
                    o.setVar(lastVar, VALUE, code);
                break;
            case 43:
                if (lastSub) {
                    lastSub.ConstantWidth = VALUE; // AcDbPolyline
                }
                else
                    o.setVar(lastVar, VALUE, code);
                break;
            case 44:
            case 45:
            case 46:
            case 47:
                if (lastSub)
                    lastSub["Something" + code] = VALUE;
                else {
                    if (!lastVar)
                        debug("lastSub", code, lastSub, lastVar);
                    o.setVar(lastVar, VALUE, code);
                }
                break;
            case 48:
                debug("Linetype scale", VALUE);
                break;
            case 49:
                break; //debug('Repeated double-precision floating-point value', lines.shift()); break
            case 50:
                if (lastSub && ["AcDbArc"].indexOf(lastSub.named) >= 0)
                    lastSub.StartAngle = (Math.PI / 180) * dxfFloat(VALUE);
                else {
                    if (lastVar)
                        o.setVar(lastVar, (Math.PI / 180) * dxfFloat(VALUE), code);
                    else
                        o.setVar("Angle0", (Math.PI / 180) * dxfFloat(VALUE), code);
                }
                break;
            case 51:
                if (lastSub && ["AcDbMlineStyle"].indexOf(lastSub.named) >= 0)
                    lastSub.StartAngle = (Math.PI / 180) * dxfFloat(VALUE);
                else if (lastSub && ["AcDbArc"].indexOf(lastSub.named) >= 0)
                    lastSub.EndAngle = (Math.PI / 180) * dxfFloat(VALUE);
                else {
                    if (lastVar)
                        o.setVar(lastVar, (Math.PI / 180) * dxfFloat(VALUE), code);
                    else
                        o.setVar("Angle1", (Math.PI / 180) * dxfFloat(VALUE), code);
                }
                break;
            case 52:
                if (lastSub && ["AcDbMlineStyle"].indexOf(lastSub.named) >= 0)
                    lastSub.EndAngle = (Math.PI / 180) * dxfFloat(VALUE);
                else {
                    if (lastVar)
                        o.setVar(lastVar, VALUE, code);
                    else
                        o.setVar("Angle2", VALUE, code);
                }
                break;
            //angles
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
            case 58:
            case 59:
                if (lastSub || !lastVar)
                    debug("lastSub", code, lastSub, lastVar);
                o.setVar(lastVar, VALUE, code);
                break;
            case 60:
                if (lastSub) {
                    lastSub.Visible = VALUE == '1'; //to do check this
                }
                else {
                    if (lastVar)
                        o.setVar(lastVar, VALUE, code);
                    else
                        o.setVar("Visible", VALUE, code);
                }
                break;
            case 62:
                // debug(lastVar, 'Color number', lines.shift());
                if (lastSub) {
                    lastSub["ColorNumber"] = VALUE.trim();
                    break;
                }
            case 65:
            case 61:
            case 63:
                if (lastSub) {
                    lastSub["Something" + code] = VALUE;
                }
                else {
                    if (lastSub || !lastVar)
                        debug("lastSub", code, lastSub, lastVar);
                    o.setVar(lastVar, VALUE, code);
                }
                break;
            case 66: //debug('Entities follow”', lines.shift()); break
                if (lastSub) {
                    lastSub.EntitiesFollow = VALUE;
                }
                else {
                    if (lastVar)
                        o.setVar(lastVar, VALUE, code);
                    else
                        o.setVar("EntitiesFollow", VALUE, code);
                }
                break;
            case 67: //debug('Space', lines.shift()); break
                if (lastSub) {
                    lastSub.Space = VALUE;
                }
                else {
                    if (lastVar)
                        o.setVar(lastVar, VALUE, code);
                    else
                        o.setVar("Space", VALUE, code);
                }
                break;
            case 68: //debug('Space', lines.shift()); break
                if (lastSub) {
                    lastSub.ViewPort = VALUE;
                }
                else {
                    if (lastVar)
                        o.setVar(lastVar, VALUE, code);
                    else
                        o.setVar("Space", VALUE, code);
                }
                break;
            case 69: //debug('Space', lines.shift()); break
                if (lastSub) {
                    lastSub.ViewPortID = VALUE;
                }
                else {
                    if (lastVar)
                        o.setVar(lastVar, VALUE, code);
                    else
                        o.setVar("Space", VALUE, code);
                }
                break;
            case 70:
                if (lastSub && ["AcDbSymbolTable"].indexOf(lastSub.named) >= 0) {
                    lastSub.MaxEntries = VALUE;
                    break;
                }
                else if (lastSub && ["AcDbDimension"].indexOf(lastSub.named) >= 0) {
                    lastSub.DimensionType = VALUE;
                    break;
                }
                else if (lastSub &&
                    ["AcDbPolyline", "AcDb2dPolyline"].indexOf(lastSub.named) >= 0) {
                    lastSub.PolylineFlag = VALUE;
                    break;
                }
                else if (lastSub) {
                    lastSub.Flags = VALUE;
                    break;
                }
                break;
            case 71:
                if (lastSub && ["AcDbXrecord"].indexOf(lastSub.named) >= 0) {
                    lastSub.TextGenFlags = VALUE;
                    break;
                }
                else if (lastSub && ["AcDbMText"].indexOf(lastSub.named) >= 0) {
                    lastSub.AttachPoint = VALUE;
                    break;
                }
                else if (lastSub && ["AcDbMlineStyle"].indexOf(lastSub.named) >= 0) {
                    lastSub.NumElemments = VALUE;
                    break;
                }
                break;
            case 72:
                if (lastSub && ["AcDbXrecord"].indexOf(lastSub.named) >= 0) {
                    lastSub.HorizontalTextJustification = VALUE;
                    break;
                }
                else if (lastSub && ["AcDbMText"].indexOf(lastSub.named) >= 0) {
                    lastSub.DrawDirection = VALUE;
                    break;
                }
                break;
            case 74:
                if (lastSub && ["AcDbXrecord"].indexOf(lastSub.named) >= 0) {
                    lastSub.VerticalTextJustification = VALUE;
                    break;
                }
            case 77:
                if (lastSub && ["AcDbXrecord"].indexOf(lastSub.named) >= 0) {
                    lastSub["Something" + code] = VALUE;
                    break;
                }
                break;
            case 75:
            case 76:
            case 78:
            case 79:
            case 73:
                if (lastSub)
                    lastSub["Something" + code] = VALUE;
                else {
                    if (!lastVar)
                        debug("lastSub", code, lastSub, lastVar);
                    else
                        o.setVar(lastVar, VALUE, code);
                }
                break;
            case 90:
                if (lastSub &&
                    ["AcDbPolyline", "AcDb2dPolyline"].indexOf(lastSub.named) >= 0) {
                    lastSub.NumberOfVertices = VALUE;
                    break;
                }
            case 91:
            case 92:
            case 93:
            case 94:
            case 95:
            case 96:
            case 97:
            case 98:
            case 99:
                if (lastSub &&
                    [
                        "AcDbXrecord",
                        "AcDbProxyObject",
                        "AcDbCellStyleMap",
                        "AcDbCellStyleMap",
                        "AcDbMaterial",
                        "AcDbVisualStyle",
                        "AcDbTableStyle",
                        "AcDbMLeaderStyle",
                        "AcDbSun",
                    ].indexOf(lastSub.named) >= 0)
                    lastSub["Something" + code] = VALUE;
                else {
                    if (lastSub || !lastVar)
                        debug("lastSub", code, lastSub, lastVar, VALUE);
                    else
                        o.setVar(lastVar, VALUE, code);
                }
                break;
            case 100:
                //  debug('Subclass', );
                lastSub = VALUE;
                lastSub = new DXFSpace.DXFOBJECT(lastSub, retry, numLines - lines.length);
                o.addSubClass(lastSub);
                break;
            case 102:
                let l = VALUE;
                if (l[0] == "{")
                    while (l.trim() != "}") {
                        //   debug('CONTROL:', l)
                        l = lines.shift().trim();
                    }
                // debug('CONTROL:', l)
                break;
            case 210:
                // debug('Extrusion direction X', VALUE);
                o.setX("" + code, "Extrusion", dxfFloat(VALUE));
                break;
            case 220:
                // debug('Extrusion direction Y', VALUE);
                o.setY("" + code, "Extrusion", dxfFloat(VALUE));
                break;
            case 230:
                //  debug('Extrusion direction Z', VALUE);
                o.setZ("" + code, "Extrusion", dxfFloat(VALUE));
                break;
            case 282:
                if (lastSub && ["AcDbXrecord"].indexOf(lastSub.named) >= 0) {
                    lastSub.Contrast = VALUE;
                    break;
                }
            case 330: // debug(lastVar, 'Soft Point Handle', VALUE);
                let handlepointer = VALUE;
                if (lastSub)
                    lastSub.SoftHandle = handlepointer;
                break;
            case 160:
            case 161:
            case 162:
            case 163:
            case 164:
            case 165:
            case 166:
            case 167:
            case 168:
            case 169:
            // let sixfour = VALUE
            // console.log('sixfour number', sixfour)
            // break;
            //3d vector
            case 110: //                debug('UCS origin x', VALUE); break
            case 120: //                debug('UCS origin y', VALUE); break
            case 130: //                debug('UCS origin z', VALUE); break
            case 111: //                debug('UCS origin x', VALUE); break
            case 121: //                debug('UCS origin y', VALUE); break
            case 131: //                debug('UCS origin z', VALUE); break
            case 112: //                debug('UCS origin x', VALUE); break
            case 122: //                debug('UCS origin y', VALUE); break
            case 132: //                debug('UCS origin z', VALUE); break
            ///------------
            case 105: //                debug('DXFOBJECT handle for DIMVAR ', VALUE); break
            case 280:
            case 281:
            case 283:
            case 284:
            case 285:
            case 286:
            case 287:
            case 288:
            case 289: //  debug('16BIT', VALUE);
            case 290:
            case 291:
            case 292:
            case 293:
            case 294:
            case 295:
            case 296:
            case 297:
            case 298: //Boolean flag value
            case 300:
            case 301:
            case 302:
            case 303:
            case 304:
            case 305:
            case 306:
            case 307:
            case 308:
            case 309: //            debug(lastVar, 'Arbitrary text strings', VALUE); break
            case 310:
            case 311:
            case 312:
            case 313:
            case 314:
            case 315:
            case 316:
            case 317:
            case 318:
            case 319: //            debug('Arbitrary binary chunks', VALUE); break
            case 340: //            debug('Hard Point Handle', VALUE); break
            case 345: //           INTERFEREOBJVS
            case 346: //           INTERFEREVPVS
            case 347: //            debug('Hard-pointer ID', VALUE); break
            case 348: //            debug('Hard-pointer ID', VALUE); break
            case 350:
            case 351:
            case 352:
            case 353:
            case 354:
            case 355:
            case 356:
            case 357:
            case 358:
            case 359: //    debug('Soft-owner handle', VALUE);
            case 360:
            case 361:
            case 362:
            case 363:
            case 364:
            case 365:
            case 366:
            case 367:
            case 368:
            case 369: //           debug('Hard-owner handle', VALUE); break
            case 370:
            case 371:
            case 372:
            case 373:
            case 374:
            case 375:
            case 376:
            case 377:
            case 378:
            case 379: //16-bit integer value
            case 380:
            case 381:
            case 382:
            case 383:
            case 384:
            case 385:
            case 386:
            case 387:
            case 388:
            case 389: //16-bit integer value
            case 390:
            case 391:
            case 392:
            case 393:
            case 394:
            case 395:
            case 396:
            case 397:
            case 398:
            case 399: ////String representing handle value of the PlotStyleName DXFOBJECT
            case 1000: //            debug(lastVar, 'ASCII string', VALUE); break
            case 1001: //           debug('Registered application name', VALUE); break
            case 1002: //            debug('Extended data control string', VALUE); break
            case 1070: //            debug('Extended data 16-bit signed integer', VALUE); break
            case 1071: //            debug('      Extended data 32-bit signed long', VALUE); break
            case 1071: //            debug('Extended data 32-bit signed long', VALUE); break
            case 140:
            case 141:
            case 142:
            case 143:
            case 144:
            case 145:
            case 146:
            case 147:
            case 148:
            case 149:
            case 270:
            case 271:
            case 272:
            case 273:
            case 274:
            case 275:
            case 276:
            case 277:
            case 278:
            case 279:
            case 170:
            case 171:
            case 172:
            case 173:
            case 174:
            case 175:
            case 176:
            case 177:
            case 178:
            case 179:
            case 1010:
            case 1011:
            case 1020:
            case 1021:
            case 1030:
            case 1031:
            case 1040:
            case 1041:
            case 1042:
            case 999:
                if (lastSub)
                    lastSub["Something" + code] = VALUE;
                else {
                    //if (!lastVar) debug('Something catch all', code, lastSub, lastVar)
                    if (lastVar)
                        o.setVar(lastVar, VALUE, code);
                }
                break;
            default:
                if (lastSub && code && ["Acdbsun"].indexOf(lastSub.named)) {
                    lastSub["Something" + code] = VALUE;
                    break;
                }
                console.error("Unknown Code:", code, lastSub);
                errors.push("Unknown Code:" + code);
                //  debug('>>>>>>>>', tempcode, 'Unknown', code, lastSub, lastVar)
                i = 1000;
                break;
        }
        tempcode = lines.shift();
    }
    // if ( primary.Objects) //somehow, sometimes this is null
    //     primary.Objects.map((v) => v.cleanup(primary));
    primary.cleanup(primary);
    let contour = primary.calcContour();
    if (contour.min.x >= BIGNUMEBR ||
        contour.min.y >= BIGNUMEBR ||
        contour.max.x <= SMALLNUMBER ||
        contour.max.y <= SMALLNUMBER) {
        if (!primary.retry) {
            return nodedxf2(data, true);
        }
        errors.push("Failed to work out overall size of contours");
        console.log(primary);
    }
    if (errors.length > 0) {
        primary.errors = errors;
        console.error(">>DXF Read Errors>>>>>>>>>", errors);
    }
    return primary;
}
